export default __webpack_public_path__ + "static/ut-screen-android-mobile@2x-3ccf60f160641b541ae273d798eac7a1.png";